import { httpClient } from '@/api/http-client'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type DeletePartnerParams = {
  company_key: string
  partner_key: string
}

const deletePartner = async ({
  company_key,
  partner_key,
}: DeletePartnerParams) => {
  const response = await httpClient('accounting-dealer').delete(
    `/v3/company/${company_key}/partner/${partner_key}`,
  )

  return response.data
}

export const useDeletePartner = (
  options?: UseMutationOptions<unknown, AxiosError, DeletePartnerParams>,
) => {
  return useMutation({
    mutationFn: deletePartner,
    ...options,
  })
}
